import { render, staticRenderFns } from "./R06.vue?vue&type=template&id=3d52861d&scoped=true"
import script from "./R06.vue?vue&type=script&lang=js"
export * from "./R06.vue?vue&type=script&lang=js"
import style0 from "./R06.vue?vue&type=style&index=0&id=3d52861d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d52861d",
  null
  
)

export default component.exports